<!-- 附件作业成绩 -->
<template>
  <div class="el-HomeworkScore">
    <el-row class="content_block">
      <TitleInfo title="附件作业成绩" :titleImg="zjie"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-col :span="6">
          <el-row style="overflow: auto;border: 1px solid #DEDEDE;margin-right: 20px;min-height:400px;height: calc(100vh - 220px);padding: 20px;">
            <el-form ref="form" :model="search1" label-width="80px">
              <el-form-item label="选择班级">
                <el-select clearable v-model="search1.schoolClassId" style="width: 100%;" placeholder="请选择班级">
                  <template v-for="(item ,index) in classList">
                    <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-input placeholder="请输入学号或姓名" style="width: calc(100% - 96px)" prefix-icon="el-icon-search" v-model="search1.studentOrName"></el-input>
              <el-button type="primary" icon="el-icon-search" @click="getStu(page_stu = 1)">搜索</el-button>
            </el-form>
            <el-table
              :data="stuData"
              border
              @row-click="tableRowClick"
              :row-class-name="tableRowClassName"
              style="width: 100%;margin-top: 10px;">
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentName}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号">
                <template slot-scope="scope">
                  <span class="c_p" :style="scope.row.studentId == seeStudentId?'color:#409EFF':''">{{scope.row.studentSn}}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin-top: 20px;">
              <el-pagination
                @size-change="handleSizeChange_stu"
                @current-change="handleCurrentChange_stu"
                :current-page.sync="currentPage1_stu"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit_stu"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next"
                :total="total_stu">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
        <el-col :span="18">
          <el-row style="margin-bottom: 20px;">
            <label>附件作业筛选：</label>
            <el-select v-model="teacherOpenCourseQuestionSettingId" placeholder="请选择">
              <template v-for="(item ,index) in examList">
                <el-option :label="item.teacherOpenCourseQuestionSettingName" :value="item.teacherOpenCourseQuestionSettingId"></el-option>
              </template>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="()=>{seeStudentId=null;getInfo(1,page = 1);}">搜索</el-button>
            <el-button type="success" icon="el-icon-printer" @click="exportInfo">导出</el-button>
          </el-row>
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
              <el-table-column prop="studentName" header-align="center" align="center" label="姓名"> </el-table-column>
              <el-table-column prop="studentSn" header-align="center" align="center" label="学号"> </el-table-column>
              <el-table-column prop="className" header-align="center" align="center" label="班级"> </el-table-column>
              <el-table-column prop="teacherOpenCourseQuestionLogUploadFile" header-align="center" align="center" label="报告名称"> </el-table-column>
              <el-table-column prop="teacherOpenCourseQuestionLogUploadFile" header-align="center" align="center" label="报告下载" width="100">
                <template slot-scope="scope">
                  <el-link type="primary"  @click="$downLoadFile(scope.row.teacherOpenCourseQuestionLogUploadFile,scope.row.studentName+'-附件作业')" target="_blank" :underline="false">下载</el-link>
                </template>
              </el-table-column>
              <el-table-column prop="teacherOpenCourseQuestionLogReply" header-align="center" align="center" label="教师评语"> </el-table-column>
              <el-table-column prop="studentScore" header-align="center" align="center" label="报告得分" width="100"> </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 16, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import {getStudentScoreList,getClassInfo,getExamAll} from "@/common/getInfo";	//加载数据
export default {
  name: "HomeworkScore",
  components: {
  	TitleInfo,
  },
  data() {
    return {
      zjie:require("../../images/course/zjie@2x.png"),
      search1:{
        bj:"",
        input:""
      },
      search:{
        teacherOpenCourseQuestionSettingId:this.$route.query.id,
        input:""
      },
      value1:"",
      tableData:[],
      stuData:[],
      noticeList:[], //当前页数据

      total: 0,
      limit:8,
      page:1,
      currentPage1_stu: 1,
      total_stu: 0,
      limit_stu:10,
      page_stu:1,
      teacherOpenCourseQuestionSettingId:this.$route.query.id,
      teacherOpenCourseId:this.$route.query.courseId,
      classList:[],
      examList:[],
      seeStudentId:"",
    };
  },
  created() {
    getExamAll({teacherOpenCourseId:this.teacherOpenCourseId,teacherOpenCourseQuestionSettingType:"HOMEWORK_FILE"}).then(ret =>{ //根据课程ID获取班级考试信息
      if(ret.code == 0){
        this.examList = ret.data;
      }
    });
    getClassInfo({teacherOpenCourseId:this.teacherOpenCourseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    });
    this.getStu();
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    handleSizeChange_stu(val) {
      console.log(`每页 ${val} 条`);
      this.limit_stu = val;
      this.getStu();
    },
    handleCurrentChange_stu(val) {
      console.log(`当前页: ${val}`);
      this.page_stu = val;
      this.getStu();
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    tableRowClick(ow, column, cell, event){
      this.onNum = ow.index;
      this.seeStudentId = ow.studentId;
      this.getInfo();
    },
    getInfo(tag){ //获取通知公告列表
      if(tag == 1){
        this.getStu();
      }
      let param = {
        limit:this.limit,
        page:this.page,
        studentId:this.seeStudentId,
        teacherOpenCourseQuestionSettingId:this.teacherOpenCourseQuestionSettingId,
        teacherOpenCourseQuestionLogStatus:1
      }
      this.$post("/api/teacherOpenCourseQuestionLog/list.do?questionSettingType=HOMEWORK_FILE",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getStu(){
      let param = {
        limit:this.limit_stu,
        page:this.page_stu,
        teacherOpenCourseQuestionSettingId:this.teacherOpenCourseQuestionSettingId,
        teacherOpenCourseQuestionLogStatus:1,
        schoolClassId:this.search1.schoolClassId,
        studentOrName:this.search1.studentOrName,
        questionSettingType:'HOMEWORK_FILE'
      }
      getStudentScoreList(param).then((ret) => {
        if(ret.code == 0){
          this.total_stu = Number(ret.count);
          this.stuData = ret.data;
          // if(ret.data.length > 0){
          //   this.seeStudentId = ret.data[0].studentId;
          //   this.getInfo();
          // }
        }
      });
    },
    exportInfo(){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downLoadFile('/jlw/teacherOpenCourseQuestionLog/homeworkFileLogExport.json?teacherOpenCourseQuestionLogStatus=1&teacherOpenCourseQuestionSettingId='+this.teacherOpenCourseQuestionSettingId, `附件作业汇总-导出 ${new Date().toLocaleString()}.xlsx`);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-HomeworkScore{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/HomeworkFJScore.vue